<template>
  <div class="container">
    <van-nav-bar
      title="告警"
      left-text=""
    />
    <van-tabs v-model:active="activeTap" @change="onClickTab" :color="'#5BA7FC'" :title-active-color="'#5BA7FC'">
            <van-tab title="系统告警"></van-tab>
            <van-tab title="用户报修"></van-tab>
        </van-tabs>
    <div class="menu">
      <div class="menuitem">
        <van-dropdown-menu active-color="#1989fa">
          <van-dropdown-item title='状态' @change="searchList" v-model="status" :options="warnStatusList" />
          <van-dropdown-item title='原因' @change="searchList" v-model="reason" :options="warnReasonList" />
        </van-dropdown-menu>
      </div>
      <div class="menuitem">
        <van-search maxlength='200' v-model="keyword" @input="searchList" shape="round" placeholder="设备编号/项目名称" />
      </div>
    </div>
<van-pull-refresh v-model="refreshing" @refresh="onRefresh" loosing-text="释放刷新" pulling-text="下拉刷新" success-text="刷新成功">
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="projectList.length > 0?'没有更多了':'暂无数据'"
      @load="onLoad"
    >
      <div class="list-box" v-if="activeTap==0">
        <div class="list clearfix" @click="goDetail(item)" :key="index" v-for="(item,index) in projectList">
          <div class="mg10">
            <span class="dot" v-if="!item.isRead"></span>
            告警原因：{{item.reasonDesc}}
          </div>
          <div class="mg10">告警时间：{{item.createTime}}</div>
          <div class="mg10 flex">
            <div>告警编码：{{item.id}}</div>
            <div class="sel_right">
              <span :class="item.warningStatus == 1?'col_r':'col_c'" >{{item.warningStatusDesc}}</span>
              <img src="../assets/img/sel_right.png" alt="">
            </div>
          </div>
          <div class="mg10 width80">告警位置：{{item.communityFullName+item.location}}</div>
          <div class="flex">
            <div >设备编码：<span class="col_b" @click.stop="changePage('chargeList',item.mainNo)">{{item.mainNo}}</span></div>
            <div>插座编号：{{item.loopNo}}</div>
          </div>
        </div>
      </div>
      <div class="list-box" v-if="activeTap==1">
        <div class="list clearfix" @click="goDetail2(item)" :key="index" v-for="(item,index) in projectList">
          <div class="mg10">
            <!-- <span class="dot" v-if="!item.isRead"></span> -->
            故障原因：{{item.repairReason&&item.repairReason.name}}
          </div>
          <div class="mg10">联系人电话：{{item.mobile}}</div>
          <div class="mg10 flex">
            <div>提交报修时间：{{item.createTime}}</div>
            <div class="sel_right">
              <span :class="item.handleStatus?'col_c':'col_b'" >{{item.handleStatus?'已处理':'待处理'}}</span>
              <img src="../assets/img/sel_right.png" alt="">
            </div>
          </div>
          <div class="mg10 width80">告警位置：{{item.device&&item.device.location}}</div>
          <div class="flex">
            <div>设备编码：<span class="col_b" @click.stop="changePage('chargeList',item.mainNo)">{{item.mainNo}}</span></div>
            <div>插座编号：{{item.loopNo}}</div>
          </div>
        </div>
      </div>
    </van-list>  
</van-pull-refresh>
    <van-tabbar v-model="active">
      <van-tabbar-item @click="changePage('home')">
        <template>
          <img class="nav-img" src="../assets/img/nav1.png" />
        </template>
        <div>首页</div>
      </van-tabbar-item>
      <van-tabbar-item>
        <template>
          <van-badge v-if="notReadNum > 0" :content="notReadNum" max="99">
            <img class="nav-img" src="../assets/img/nav2_h.png" />
          </van-badge>
          <img v-else class="nav-img" src="../assets/img/nav2_h.png" />
        </template>
        <div class="col_b">告警</div>
      </van-tabbar-item>
      <van-tabbar-item @click="changePage('mine')">
        <template>
          <img class="nav-img" src="../assets/img/nav3.png" />
        </template>
        <div>我的</div>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
  import axios from '@/axios.js';
  import {NavBar,Icon,Image,Toast,Loading,Search,Tabbar,TabbarItem,DropdownMenu, DropdownItem,List,Badge,Tab, Tabs,PullRefresh  } from 'vant';
  export default {
    data() {
      return {
        activeTap:0,
        active:1,
        notReadNum:0,//未读数量
        status: '',//告警状态
        reason: '',//告警原因
        url:'/device/devicewarningpagelist',
        keyword: '',
        allCount:0,
        pageIndex:1,
        pageSize:10,
        refreshing:false,
        loading: false,
        finished:false,
        projectList:[],
        warnReasonList:[],
        warnStatusList:[],
       
      };
    },
    components: {
      [NavBar.name]:NavBar,
      [Icon.name]:Icon,
      [Image.name]:Image,
      [Toast.name]:Toast, 
      [Loading.name]:Loading,
      [Search.name]:Search,
      [Tabbar.name]:Tabbar,
      [TabbarItem.name]:TabbarItem,
      [DropdownMenu.name]:DropdownMenu,
      [DropdownItem.name]:DropdownItem,
      [List.name]:List,
      [Badge.name]:Badge,
      [Tab.name]: Tab,
      [Tabs.name]: Tabs,
      [PullRefresh.name]: PullRefresh,
    },
    activated(){
      if(this.$route.query.isDetail==1){
        this.projectList=[]
            this.finished=false;
            this.pageIndex=1
            this.getProjectList()
      }
    },
    methods: {
      onRefresh(){
          this.finished=false;
          this.projectList=[]
          this.pageIndex=1;
          this.getMoreList();
      },
       onClickTab(title){
        this.keyword=''
        this.status= ''
        this.reason= ''
            this.activeTap=title
            this.getCommon();
            this.projectList=[]
            this.finished=false;
            this.pageIndex=1
            this.getProjectList()
        },
      changePage(url,mainNo){     
        this.$router.push({path: url+".html",query:{ mainNo:mainNo,back:true}})
      },
      goDetail(item){
        this.$router.push({path: "warnDetail.html",query:{rowId:item.id}})
      },
      goDetail2(item){
        this.$router.push({path: "repairDetail.html",query:{rowId:item.id}})
      },
      onSubmit(values) {
        console.log('submit', values);
      },
      onLoad(){
        // 异步更新数据
        setTimeout(()=>{
          this.pageIndex++;
          this.getMoreList();
        },500)
      },
      searchList(item){
        console.log(item)
        var regx = /^[A-Za-z0-9\u4e00-\u9fa5]+$/;
        if(!regx.test(this.keyword)){
          this.keyword = '';
        }
        this.projectList=[]
        this.finished=false;
        this.pageIndex = 1;
        this.getProjectList();
      },
      getProjectList() {
        let filter=null
        if(this.activeTap==0){
          this.url='/device/devicewarningpagelist'
          filter={
            keyword: this.keyword,
            warningReason: this.reason,
            warningStatus: this.status
          }
          }else{
            this.url='/repair/pagelist'
            filter={
              keyword: this.keyword,
              repairReasonId: this.reason,
              handleStatus:this.status
            }
          }
        axios.post(this.url,{
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          filter: filter
        }).then((res)=>{
          this.projectList = res.data.list;
          this.allCount = res.data.total;
        })
      },
      getMoreList() {
        let filter=null
        if(this.activeTap==0){
          this.url='/device/devicewarningpagelist'
          filter={
            keyword: this.keyword,
            warningReason: this.reason,
            warningStatus: this.status
          }
          }else{
            this.url='/repair/pagelist'
            filter={
              keyword: this.keyword,
              repairReasonId: this.reason,
              handleStatus:this.status
            }
          }
        axios.post(this.url,{
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          filter:filter,
        }).then((res)=>{
          this.projectList = this.projectList.concat(res.data.list);
          this.allCount = res.data.total;
          // 加载状态结束
          this.loading = false;
          this.refreshing=false;
          // 数据全部加载完成
          if (this.pageIndex * this.pageSize >= this.allCount) {
            this.finished = true;
          }
        })
      },
      getCommon() {
        if(this.activeTap==0){
        //告警原因
        axios.get("/common/getwarningreason",{
        }).then((res)=>{
          this.warnReasonList = res.data;
          this.warnReasonList.forEach(item => {
            item.text = item.description;
            item.value = item.id;
          });
          this.warnReasonList.unshift({
            text:'全部',value:''
          })
        })

        //告警状态
        axios.get("/common/getwarningstatus",{
        }).then((res)=>{
          this.warnStatusList = res.data;
          this.warnStatusList.forEach(item => {
            item.text = item.description;
            item.value = item.id;
          });
          this.warnStatusList.unshift({
            text:'全部',value:''
          })
        })
        }else if(this.activeTap==1){
          //报修原因
        axios.get("dictdetail/getdictdetailbyparentcode?dictCode=RepairReason",{
        }).then((res)=>{
          this.warnReasonList = res.data;
          this.warnReasonList.forEach(item => {
            item.text = item.name;
            item.value = item.id;
          });
          this.warnReasonList.unshift({
            text:'全部',value:''
          })
        })
        this.warnStatusList=[{
          text:'全部',value:''
        },{text:'已处理',value:true},{text:'待处理',value:false}]
        }
      },
      getDataObj() {
        //首页各个数据统计
        axios.get("/home/statisticsdata",{
        }).then((res)=>{
          this.notReadNum = res.data.noreadWarningCount;
        })
      },

      onClickLeft() {
        this.$router.go(-1);
      },
    },
    computed:{
    },
    created () {
      this.getCommon();
      this.getDataObj();
      this.reason = this.$route.query.warningReason *1;
      if(this.$route.query.warningReason){
        this.status = 1
      }
      this.getProjectList();
    },
    mounted () {},
    destroyed () {}
  }
</script>

<style lang="less"> 
  @import "../assets/css/default.less";
  [v-cloak]{ 
    display:none !important;
  }
</style>
<style lang="less" scoped>
  body,html{width: 100%;height: 100%;background: #F0F4F7}
  .container{
    width: 100%;height: 100%;letter-spacing:0px;background: #F0F4F7;
    padding-bottom: 90px;
  }
  .list-box{
    width: 100%;
    color: #373737;
    .list{
      font-size: 14px;
      width: 100%;
      background: #fff;
      margin: 12px 0;
      padding: 12px;
      position: relative;
      .sel_right{
        img{
          width: 6px;
          margin-left: 8px;
          vertical-align: middle;
          margin-bottom: 3px;
        }
      }
    }
    .width80{width: 80%;}
    .mg10{margin-bottom: 10px;}
    .mg20{margin: 14px 0 25px 0;}
    .bold{font-weight: bold;}
  }

  .dot{
    width: 10px;
    height: 10px;
    display: inline-block;
    vertical-align: middle;
    border-radius: 10px;
    text-align: center;
    background: #ee0a24;
  }

  /deep/.van-nav-bar__title{font-weight: bold;}

  // *************************** 底部导航样式重置 ******************************
  .van-tabbar{
    padding: 8px 0 20px 0;
    border-radius: 14px 14px 0px 0px;
    overflow: hidden;
    box-shadow: 0px 0px 6px 1px rgba(190,228,255,0.71);
  }
  /deep/.van-info{top: 5px; right: -6px;}
  .nav-img{width: 24px;margin-bottom: 4px;}
  .col_b{color: #2FAAFF;font-weight: bold;}

  .menu{
    width: 100%;
    background: #fff;
    .menuitem{
      width: 50%;
      display: inline-block;
    }
  }
  /deep/.van-dropdown-menu__bar{
    box-shadow: none;
  }
</style>
